<template>
    <div>
        <v-fab-transition>
            <v-btn large fab fixed bottom right dark class="support-chat-btn"
                   v-show="fab" v-scroll="onScroll" id="SupportChatBtn"
                   elevation="5" color="white">
                <v-icon large color="secondary">mdi-forum</v-icon>
                <v-tooltip activator="#SupportChatBtn" left><span>پشتیبانی آنلاین</span></v-tooltip>
            </v-btn>
        </v-fab-transition>
        <v-snackbar v-model="message.active"  transition="slide-x-reverse-transition"
                    style="padding-right: 100px; padding-bottom: 5px"
                    :color="message.color" bottom left text rounded :multi-line="true">
            <v-icon class="ml-1" :color="message.color">mdi-{{message.icon}}</v-icon>
            {{ message.text }}
            <template v-slot:action="{ attrs }">
                <v-btn :color="message.color" small text v-bind="attrs" @click="message.active = false">بستن</v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "SupportChatBtn",
        data(){
            return{
                fab: false,
                message: {
                    active: false,
                    code: "",
                    color: "",
                    icon: "",
                    text: ""
                },
            }
        },
        computed: mapGetters(["notification"]),
        methods:{
            onScroll (e) {
                if (typeof window === 'undefined') return
                const top = window.pageYOffset ||   e.target.scrollTop || 0
                // this.fab = top > 400
                this.fab = true

            },
        },
        mounted(){
            setTimeout(() => {
                this.fab = true
                this.message = this.notification
            },3000)
        }
    }
</script>

<style scoped>
    .support-chat-btn{
        z-index: 99;
    }
</style>
